import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Reveal, PointerGlow } from './motion';

const CTASection = ({ title = 'Let’s secure what’s next.' }) => (
  <section className="relative overflow-hidden py-7">
    <PointerGlow />
    <div className="absolute inset-0 grid-lines" />
    <Reveal className="relative max-w-6xl mx-auto px-6 text-center">
      <p className="font-mono-label text-[var(--red)] mb-8">Ready when you are</p>
      <h2 className="font-display text-6xl sm:text-8xl lg:text-9xl leading-[0.95] max-w-5xl mx-auto">{title}</h2>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link to="/contact" className="btn btn-primary">Schedule a consultation</Link>
        <a href={`tel:${companyInfo.phone}`} className="btn btn-ghost"><Phone className="w-4 h-4" />{companyInfo.phone}</a>
      </div>
      <a href={`mailto:${companyInfo.email}`} className="mt-8 inline-flex items-center gap-2 text-[var(--muted)] hover:text-[var(--paper)] transition-colors"><Mail className="w-4 h-4" />{companyInfo.email}</a>
    </Reveal>
  </section>
);

export default CTASection;
